import { XMarkIcon } from '@heroicons/react/24/outline';

function Modal({ title, onClose, children, maxWidthClass = 'max-w-md' }) {
  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" />
      <div className={`relative w-full ${maxWidthClass} bg-white rounded-lg shadow-xl overflow-hidden max-h-[90vh] flex flex-col`}>
        <div className="flex items-center justify-between px-5 py-4 bg-[#3f6d8e] shrink-0">
          <h2 className="text-lg font-semibold text-white">{title}</h2>
          <button type="button" onClick={onClose} className="p-1 text-gray-200 hover:text-white">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="p-5 space-y-3 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
